import type { PickerLocale } from 'antd/es/date-picker/generatePicker';
export const MAX_IMAGE_FILE_SIZE = 500 * 1024; 
export const menuitems = [
    {
      key: '/main',
      label: '数据看板'
    },
    {
      key: '/main/account',
      label: '账户管理'
    },
    {
      key: '/main/merchant',
      label: '商户管理'
    },
    {
      key: '/main/channel',
      label: '渠道管理'
    },
    {
      key: '/main/supplyProducts',
      label: '权益活动管理'
    },
    {
      key: '/main/products',
      label: '权益管理'
    },
    {
      key: '/main/activities',
      label: '权益包管理'
    },
    {
      key: '/main/user',
      label: '用户管理'
    },
    {
      key: '/main/claims',
      label: '领取记录'
    },
    {
      key: '/main/afterSales',
      label: '售后管理'
    },
    {
      key: '/main/customerService',
      label: '客服管理'
    }
  ]
  export const menuMap:{[key: string]:string} = {
    "/main": "dataBoard",
    "/main/account": "account",
    "/main/channel": 'channel',
    "/main/supplyProducts": "supplyProducts",
    "/main/products": "products",
    "/main/activities": "activities",
    "/main/user": "user",
    "/main/claims": "claims",
    "/main/merchant": "merchant",
    "/main/afterSales": "afterSales",
    "/main/activityProducts":"activities",
    "/main/customerService":"customerService"
  }

export const menuPermissions = {
  'SuperUser':{
    "dataBoard":{
      edit: true,
      view: true
    },
    "account": {  
      edit: true,
      view: true
    },
    "channel": {  
      edit: true,
      view: true
    },
    "supplyProducts": {  
      edit: true,
      view: true
    },
    "products": {  
      edit: true,
      view: true
    },
    "activities": {  
      edit: true,
      view: true
    },
    "user": {  
      edit: true,
      view: true
    },
    "claims": {  
      edit: true,
      view: true
    },
    "merchant": {  
      edit: true,
      view: true
    },
    "afterSales": {  
      edit: false,
      view: true
    },
    "customerService": {
      edit: false,
      view: false
    }
  },
  'Merchant':{
    "dataBoard":{
      edit: true,
      view: true
    },
    "account": {  
      edit: false,
      view: false
    },
    "channel": {  
      edit: true,
      view: true
    },
    "supplyProducts": {  
      edit: true,
      view: true
    },
    "products": {  
      edit: false,
      view: true
    },
    "activities": {  
      edit: true,
      view: true
    },
    "user": {  
      edit: false,
      view: false
    },
    "claims": {  
      edit: true,
      view: true
    },
    "merchant": {  
      edit: false,
      view: false
    },
    "afterSales": {  
      edit: false,
      view: true
    },
    "customerService": {
      edit: true,
      view: true
    }
  },
  'CustomerService':{
    "dataBoard":{
      edit: true,
      view: true
    },
    "account": {  
      edit: false,
      view: true
    },
    "channel": {  
      edit: false,
      view: true
    },
    "supplyProducts": {  
      edit: false,
      view: true
    },
    "products": {  
      edit: false,
      view: true
    },
    "activities": {  
      edit: false,
      view: true
    },
    "user": {  
      edit: false,
      view: true
    },
    "claims": {  
      edit: false,
      view: true
    },
    "merchant": {  
      edit: false,
      view: true
    },
    "afterSales": {  
      edit: true,
      view: true
    },
    "customerService": {
      edit: false,
      view: false
    }
  }
};


export const roleMap:{[key: string]:string} = {
  "SuperUser": "超级用户",
  "Merchant": '商户',
  "CustomerService": "客服",
}

export const roleList = [
  { value:'SuperUser',label:'超级用户' },
  { value:'Merchant',label:'商户'},
  { value:'CustomerService',label:'客服'},
]

export const accountStatusList = [
  {
      value:false,
      label:'启用' 
  },{
      value:true,
      label:'禁用'
  }
]

export const categoryList = [
  {value:'视频音频',label:'视频音频'},
  {value:'娱乐工具',label:'娱乐工具'},
  {value:'生活服务',label:'生活服务'},
  {value:'美食餐饮',label:'美食餐饮'},
  {value:'出行服务',label:'出行服务'},
  {value:'其他',label:'其他'}
]

export const cycleList = [
  {
      value: 2,
      label: '每周',
  },
  {
      value: 3,
      label: '每月',
  }
]

export const productGradeList = [
  {
      value: 'A',
      label: 'A',
  },
  {
      value: 'B',
      label: 'B',
  },
  {
    value: 'C',
    label: 'C',
  },
  {
      value: 'D',
      label: 'D',
  }
]

export const productTypeList = [
  {
      value: '直充',
      label: '直充',
  },
  {
      value: '卡密',
      label: '卡密',
  }
]

export const accountTypeList = [
  {
      value: '手机号',
      label: '手机号',
  },
  {
      value: 'QQ号',
      label: 'QQ号', 
  },
  {
      value: '微博昵称',
      label: '微博昵称', 
  },
  {
      value: '剪映号',
      label: '剪映号', 
  }
]

export const gradeList = [
  { label: 'A', value: 'gradeACount' },
  { label: 'B', value: 'gradeBCount' },
  { label: 'C', value: 'gradeCCount' },
];
export const imgSizeList = {
  instructionsImg:'700*149',
  cardImg:'750*547',
  backgroundImg:'412*261',
  imageUrl:'750*1400',

  productImg:'400*400',
  productIcon:'200*200',
}

export const ExampleImgList = { // 示例图片
  // instructionsImg:'', // 使用说明图片
  cardImg:'https://fulu-media.oss-cn-hangzhou.aliyuncs.com/public/privilegeMall/2.png', // 权益包卡片
  backgroundImg:'https://fulu-media.oss-cn-hangzhou.aliyuncs.com/public/privilegeMall/1.png', // 权益包封面
  imageUrl:'https://fulu-media.oss-cn-hangzhou.aliyuncs.com/public/privilegeMall/5.png', // 权益包首页

  productImg:'https://fulu-media.oss-cn-hangzhou.aliyuncs.com/public/privilegeMall/3.png', // 权益图片
  productIcon:'https://fulu-media.oss-cn-hangzhou.aliyuncs.com/public/privilegeMall/4.png', // 权益图标
}

export const TooltipTextList = {
  cycleNum:'填入3，即代表该周期内可领取权益数量为3，建议默认填入1',
  instructions:'权益包使用规则介绍及特殊情况说明',
  channelProductId:'权益商品对应的fp权益商品编码',
  arrivalTime:'设置权益商品延迟到账的时间',
  productGrade:'以权益商品上的档次等级为标准，填写该档次权益商品的可领取次数，建议A档3次:成本＞15； B档6次：成本＞10； C档12次：成本＜5 ；D档：免费领取，单次卡',
  accountType:'根据权益充值类型填写，默认以手机号的形式充值',

  collectTimeLimit:'以日为单位，每天开始领取权益的时间', // 可领取时间
  collectTimeValidity:'从可领取时间开始计时，可领取的时间区间', // 延长时长（分钟）
  delayCollectionTime:'购买权益后，针对首期权益可配置延迟领取时间' // 延迟领取（小时）
}

export const getSafeLocale = {
        lang: {
            locale: 'zh-cn',
            months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            monthsShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
            weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
            today: '今天',
            now: '此刻',
            backToToday: '返回今天',
            ok: '确定',
            clear: '清除',
            month: '月',
            year: '年',
            timeSelect: '选择时间',
            dateSelect: '选择日期',
            weekSelect: '选择周',
            monthSelect: '选择月份',
            yearSelect: '选择年份',
            decadeSelect: '选择年代',
            yearFormat: 'YYYY年',
            dateFormat: 'M/D/YYYY',
            dayFormat: 'D',
            dateTimeFormat: 'M/D/YYYY HH:mm:ss',
            monthBeforeYear: true,
            previousMonth: '上个月 (PageUp)',
            nextMonth: '下个月 (PageDown)',
            previousYear: '上一年 (Control + left)',
            nextYear: '下一年 (Control + right)',
            previousDecade: '上一年代',
            nextDecade: '下一年代',
            previousCentury: '上一世纪',
            nextCentury: '下一世纪',
        },
        timePickerLocale: {}
    } as unknown as PickerLocale;